interface ToastProps {
  message: string | null;
}

export default function Toast({ message }: ToastProps) {
  if (!message) {
    return null;
  }
  return (
    <div className="fixed bottom-8 left-1/2 z-[60] flex -translate-x-1/2 animate-fade-in items-center gap-2 rounded-md bg-foreground-950 px-4 py-2.5 text-sm text-background-50">
      <i className="ri-checkbox-circle-line text-base text-accent-400" />
      {message}
    </div>
  );
}